export default __webpack_public_path__ + "static/media/ic-data-operator.c3174ee6.svg";